KMVP.privacy = KMVP.privacy || {};

KMVP.privacy.isGTMStartInitiated = false;

KMVP.privacy.checkAndStartGTM = function () {
    // check start flag to avoid multiple starts on privacy page after consent change
    if (KMVP.privacy.isGTMStartInitiated) {
        return;
    }
    KMVP.privacy.isGTMStartInitiated = true;
    // check whether GTM script is rendered on page (tracking number exists)
    if (typeof startGTM !== 'function') {
        return;
    }
    startGTM();
    KMVP.privacy.setUserTrackingCookie();
};


KMVP.privacy.setUserTrackingCookie = function () {
    KMVP.registration.handleGATracking('currentLogin');
    KMVP.registration.handleGATracking('currentRegistration');
};

$(document).ready(function () {
    KMVP.privacy.checkAndStartGTM();
});

// Set to the same value as the web property used on the site
$(document).on('click', 'a[data-event="google-opt-out"]', function (e) {
    e.preventDefault();
    googleOptOut();
});
